module.exports = __webpack_public_path__ + "media/images/icon-svg/warning-48723970611217ae251e2ef3b6aa46fb.svg";